const formSlideSE = {
		init() {
				var element = document.querySelectorAll(".form-step-se");
				var startActive = document.querySelectorAll(".form-landingpage");

				if (element.length > 0) {

						//Set the first tabs to be active
						for (var y = 0; y < startActive.length; y++) {
								startActive[y].classList.add("active");
						}
						this.events();
				}

		},

		events() {
				var element = document.querySelectorAll(".form-step-se");
				let active = document.querySelector(".active");
				var btnChange = document.querySelectorAll(".form-btn");
				var calcWrap = document.querySelector(".calculator--wrapper");
				var stepCounter = document.querySelector(".step-counter");
				let formArrow = document.querySelectorAll(".arrow-bounce");

				if (window.location.href.indexOf("laanekurv") !== -1) {
						calcWrap.classList.add("hidden");
				}

				var prev = document.querySelectorAll(".prev");
				for (let o = 0; o < prev.length; o++) {

						prev[o].addEventListener("click", function () {

								// Reset Arrow
								for (let i = 0; i < formArrow.length; i++) {
										formArrow[i].style.top = 40 + "px";
								}

								var parentStep = this.closest(".form-step-se");
								var sibling = parentStep.previousElementSibling;

								parentStep.classList.remove("active");
								sibling.classList.add("active");

								//change counter highlight
								var highlight = document.querySelector(".highlight");
								var highlightSibling = highlight.previousElementSibling;
								highlight.classList.remove("highlight");
								highlightSibling.classList.add("highlight");
						})
				}


				//Create steps
				let counter = 1;

				//if (document.querySelector(".create-steps-se")) {
				//		for (let x = 0; x < element.length; x++) {
				//				var stepParent = document.querySelector(".create-steps-se");
				//				var node = document.createElement("LI");
				//				var textnode = document.createTextNode(counter++);
				//				node.appendChild(textnode);
				//				stepParent.appendChild(node);

				//				stepParent.firstChild.classList.add("highlight");
				//		}
				//}


				for (let i = 0; i < btnChange.length; i++) {
						btnChange[i].addEventListener("click", function () {
								let form = document.querySelector("#loanCartForm");
								console.log($(form).valid())
								if ($(form).valid()) {
										// Reset Arrow
										for (let i = 0; i < formArrow.length; i++) {
												formArrow[i].style.top = 40 + "px";
										}

										//Get parent step and sibling
										var parentStep = this.closest(".form-step-se");
										var sibling = parentStep.nextElementSibling;

										parentStep.classList.remove("active");
										sibling.classList.add("active");										

										//change counter highlight
										var highlight = document.querySelector(".highlight");
										var highlightSibling = highlight.nextElementSibling;
										highlight.classList.remove("highlight");
										highlightSibling.classList.add("highlight");

										$('html, body').animate(
												{
														scrollTop: $('.form-step-se.active').offset().top,
												},
												500,
												'linear'
										)

										return;
								}

						})
				}

		}
}

export default formSlideSE.init()
